/**
 * email-signup.js - MegaRTL
 * Reproduces Horizon's behavior for email signup forms.
 */

(function () {
    const initEmailSignup = () => {
        const signupBlocks = document.querySelectorAll('.email-signup-block');

        signupBlocks.forEach(block => {
            const form = block.querySelector('form');
            const button = block.querySelector('.email-signup__button');

            if (!form || !button) return;

            form.addEventListener('submit', () => {
                // Add loading state behavior
                button.classList.add('loading');
                button.setAttribute('disabled', 'disabled');
            });
        });
    };

    // Initialize on DOM load
    document.addEventListener('DOMContentLoaded', initEmailSignup);

    // Initialize on section load in theme editor
    document.addEventListener('shopify:section:load', (event) => {
        if (event.target.querySelector('.email-signup-block')) {
            initEmailSignup();
        }
    });
})();
